/********************************************************************
 * Project: WDCK（2021）
 * Class: HeaderComponent
 * ----------------------------------------
 * <summary>
 * HeaderComponent
 * </summary>
 * <history>
 *      ANBD     2021/12/25      Create
 * </history>
 ********************************************************************/
import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { jaLocale, viLocale } from 'ngx-bootstrap/locale';
import { AppConfigService } from 'src/app/helpers/app-init-config.service';
import { LanguageTranslateService } from 'src/app/services/lang-translate.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { Utility } from 'src/app/shared/utility/utility';
import { selectedMstHTOrg } from 'src/app/store/selectors/mstHTOrg.selector';
import { HeaderService } from '../header/header.service';
import { LoadingService } from '../loading/loading.service';
import { map } from 'rxjs/internal/operators/map';

defineLocale('ja', jaLocale);
defineLocale('vi', viLocale);

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  languageUse: any;
  isLogin = false;
  HTOrgName: any;
  lstLang = ['en', 'vi', 'ja'];
  touchMenu = false;
  constructor(
    public translate: TranslateService,
    public lang: LanguageTranslateService,
    public modalService: NgbModal,
    public ulti: Utility,
    private localeService: BsLocaleService,
    private dialogModalService: DialogModalService,
    private store: Store<any>,
    private router: Router,
    private eRef: ElementRef,
    private auth: HeaderService) {
      // Check HTOrgCode by url
      this.store.select(selectedMstHTOrg).pipe(map(i => i)).subscribe(item => {
        if (!this.ulti.isNullOrEmpty(item)) {
          this.HTOrgName = item.HTOrgName;
        }
      });
  }
  // tslint:disable-next-line: quotemark
  @HostListener("window:beforeunload", ["$event"])
  clearLocalStorage(event) {
      localStorage.removeItem('language');
  }
  ngOnInit(): void {
    this.setLanguage();
    setInterval(() => {
      if (!this.ulti.isNullOrEmpty(localStorage.getItem('fLogin'))) {
        if (localStorage.getItem('fLogin') === 'true'){
          this.isLogin = true;
        }
      }else{
        this.isLogin = false;
      }
    }, 100);
  }
  setLanguage() {
    let strLang = sessionStorage.getItem('sslanguage');
    if (this.ulti.isNullOrEmpty(strLang)) {
      strLang = localStorage.getItem('language');
    }
    if (this.ulti.isNullOrEmpty(strLang)) {
        strLang = navigator.language || window.navigator.language;
        if (this.ulti.isNullOrBlank(strLang)) {
          strLang = AppConfigService.settings.defaultLanguage;
        } else {
          strLang = strLang.toLowerCase();
        }
        if (!this.lstLang.includes(strLang)) {
          strLang = AppConfigService.settings.defaultLanguage;
        }
    }
    this.switchLanguage(strLang);
  }
  switchLanguage(language: string) {
    this.translate.use(language);
    this.lang.setLanguage(language);
    localStorage.setItem('language', language);
    sessionStorage.setItem('sslanguage', language);
    this.languageUse = language;
    // Change language datepicker
    this.localeService.use(language);
    this.ulti.strCurrentLang = language;
  }
  logout() {
    const message = this.translate.instant('MESS_CNF_LOGOUT');
    this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
      if (res.isOk()) {
        this.auth.RemoveToken().subscribe(
          value => {
            localStorage.clear();
            sessionStorage.clear();
            localStorage.fLogin = 'false';
            this.router.navigateByUrl('/logout');
            this.isLogin = false;
            this.touchMenu = false;
          }
        );
      }
    });
  }
  login(){
    this.router.navigateByUrl('');
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.touchMenu = false;
    }
  }
}
